var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMonetization = function SvgMonetization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#monetization_svg__a)",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.22 12.367 2.063-3.532a.633.633 0 0 0-.242-.875.66.66 0 0 0-.326-.085h-6.928a.659.659 0 0 0-.568.32.632.632 0 0 0 0 .64l2.065 3.532c-1.037.662-5.907 2.45-5.907 7.7 0 4.075 3.598 7.058 7.766 7.058 4.167 0 7.984-2.983 7.984-7.058-.002-5.046-4.776-6.843-5.908-7.7Z",
    fill: "#FFE1CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.75 4.375V2.179A1.316 1.316 0 0 0 21.43.875H2.188A1.308 1.308 0 0 0 .875 2.172v15.773a1.317 1.317 0 0 0 1.32 1.305H7M.875 5.25h12.25M17.082 22.276a2.591 2.591 0 0 0 2.168 1.021c1.329 0 2.407-.808 2.407-1.805 0-.996-1.078-1.804-2.407-1.804s-2.406-.809-2.406-1.806c0-.998 1.077-1.805 2.406-1.805a2.594 2.594 0 0 1 2.168 1.02M19.25 23.297V24.5M19.25 14.875v1.202"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "monetization_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};

export default SvgMonetization;